var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { UserType } from "healthex-common/user.dtos";
export class WelcomeBasicOrgDetailsViewModel {
    constructor(container) {
        this.authManager = container.authManager;
        this.welcomeUserUIManager = container.welcomeUserUIManager;
        this.routingUIManager = container.routingUIManager;
    }
    get organizationId() {
        return this.authManager.orgId;
    }
    get showProgressBar() {
        if (!this.routingUIManager.currentRoute)
            return false;
        return true;
    }
    get progressBarPercentage() {
        return this.welcomeUserUIManager.progressBarPercentage;
    }
    onSave() {
        if (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION) {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS);
        }
        else {
            this.routingUIManager.navigateTo(NamedRoutes.WELCOME_ORG_USER_INVITE);
        }
    }
}
__decorate([
    computed
], WelcomeBasicOrgDetailsViewModel.prototype, "organizationId", null);
__decorate([
    computed
], WelcomeBasicOrgDetailsViewModel.prototype, "showProgressBar", null);
__decorate([
    computed
], WelcomeBasicOrgDetailsViewModel.prototype, "progressBarPercentage", null);
